module.exports = __webpack_public_path__ + "img/home-page2.1dc7f2d7.png";